(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('GeodataSearch', GeodataSearch);

    GeodataSearch.$inject = ['$resource'];

    function GeodataSearch($resource) {
        var resourceUrl =  'api/_search/geodata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
